import Image from 'next/image';
import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';

export const ThumbnailWrapper = styled.div`
  width: 100%;
  cursor: pointer;
  border-radius: 7px;
  overflow: hidden;
`;

export const ThumbnailImage = styled(Image)`
  width: 100%;
  height: 112px;
  display: block;
  object-fit: cover;

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 167px;
  }
`;
